// import { useEffect, useState } from 'react';
// import axios from 'axios';
// import API_BASE_URL from '../components/baseurl';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// // Setup Axios default headers and token refresh interceptor
// axios.defaults.baseURL = API_BASE_URL;

// const setupAxiosInterceptors = () => {
//   axios.interceptors.response.use(
//     res => res,
//     async err => {
//       const originalRequest = err.config;
//       if (err.response?.status === 401 && !originalRequest._retry) {
//         originalRequest._retry = true;
//         const refreshToken = localStorage.getItem('refresh_token');
//         if (refreshToken) {
//           try {
//             const res = await axios.post('/api/token/refresh/', { refresh: refreshToken });
//             localStorage.setItem('access_token', res.data.access);
//             axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`;
//             originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
//             return axios(originalRequest);
//           } catch (error) {
//             toast.error("Session expired. Please login again.");
//             localStorage.removeItem('access_token');
//             localStorage.removeItem('refresh_token');
//           }
//         }
//       }
//       return Promise.reject(err);
//     }
//   );
// };

// const MyContent = () => {
//   const [contents, setContents] = useState([]);
//   const [form, setForm] = useState({
//     title: '',
//     body: '',
//     category: '',
//     customCategory: '',
//     subcategory: '',
//     customSubcategory: '',
//     file: null,
//     fileUrl: '',
//     fileType: '',
//   });

//   const [editingId, setEditingId] = useState(null);
//   const [editForm, setEditForm] = useState({ title: '', body: '' });
//   const [loading, setLoading] = useState(false);

//   const accessToken = localStorage.getItem('access_token');

//   useEffect(() => {
//     setupAxiosInterceptors();

//     if (!accessToken) return;
//     setLoading(true);
//     axios
//       .get('/api/my-content/', {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       })
//       .then((res) => setContents(res.data))
//       .catch((err) => toast.error('Failed to load content'))
//       .finally(() => setLoading(false));
//   }, [accessToken]);

//   // const handleChange = (e) => {
//   //   setForm({ ...form, [e.target.name]: e.target.value });
//   // };
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prevForm) => ({
//       ...prevForm,
//       [name]: value,
//     }));
//   };



//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // Replace 'other' with custom inputs
//     const finalCategory = form.category === 'other' ? form.customCategory : form.category;
//     const finalSubcategory = form.subcategory === 'other' ? form.customSubcategory : form.subcategory;

//     const formData = {
//       title: form.title,
//       body: form.body,
//       category: finalCategory,
//       subcategory: finalSubcategory,
//       file_url: form.fileUrl,
//       file_type: form.fileType,
//     };
//     try {
//       const res = await axios.post('/api/my-content/', formData, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setContents((prev) => [res.data, ...prev]);
//       setForm({
//         title: '',
//         body: '',
//         category: '',
//         customCategory: '',
//         file: null,
//         fileUrl: '',
//         fileType: '',
//       });
//       toast.success("Content posted successfully");
//     } catch (err) {
//       toast.error(err.response?.data?.detail || "Error posting content");
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`/api/my-content/${id}/`, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setContents((prev) => prev.filter((item) => item.id !== id));
//       toast.success("Content deleted");
//     } catch (err) {
//       toast.error("Failed to delete content");
//     }
//   };
//   // const handlePostGlobal = async (id) => {
//   //   try {
//   //     const res = await axios.patch(
//   //       `${API_BASE_URL}/api/my-content/${id}/`,
//   //       { is_public: true },
//   //       {
//   //         headers: { Authorization: `Bearer ${accessToken}` },
//   //       }
//   //     );
//   //     setContents((prev) =>
//   //       prev.map((item) => (item.id === id ? res.data : item))
//   //     );
//   //     toast.success("Posted to Global Feed!");
//   //   } catch (err) {
//   //     console.error(err);
//   //     toast.error("Failed to post globally.");
//   //   }
//   // };
//   const togglePublic = async (id, makePublic) => {
//     try {
//       const res = await axios.patch(
//         `${API_BASE_URL}/api/my-content/${id}/`,
//         { is_public: makePublic },
//         {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         }
//       );
//       setContents((prev) =>
//         prev.map((item) => (item.id === id ? res.data : item))

//       ); toast.success("Changes to Global Feed!");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to post globally.");
//     }
//   };
//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     setForm((prev) => ({ ...prev, file }));

//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('upload_preset', 'your_unsigned_upload_preset');

//     try {
//       const res = await axios.post('https://api.cloudinary.com/v1_1/your_cloud_name/auto/upload', formData);
//       setForm((prev) => ({
//         ...prev,
//         fileUrl: res.data.secure_url,
//         fileType: file.type.split('/')[0], // image, video, application (for pdf)
//       }));
//     } catch (error) {
//       console.error('Cloudinary upload failed', error);
//     }
//   };




//   const startEdit = (content) => {
//     setEditingId(content.id);
//     setEditForm({ title: content.title, body: content.body });
//   };

//   const handleEditChange = (e) => {
//     setEditForm({ ...editForm, [e.target.name]: e.target.value });
//   };


//   const submitEdit = async (id) => {
//     try {
//       const res = await axios.put(`/api/my-content/${id}/`, editForm, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//       });
//       setContents((prev) => prev.map((item) => (item.id === id ? res.data : item)));
//       setEditingId(null);
//       toast.success("Content updated");
//     } catch (err) {
//       toast.error("Failed to update content");
//     }
//   };

//   if (!accessToken) {
//     return <p>Please login to see your content.</p>;
//   }

//   return (
//     <div className="position-relative">
//       <ToastContainer />

//       {loading && (
//         <div
//           className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
//           style={{
//             backgroundColor: 'rgba(255, 255, 255, 0.7)',
//             backdropFilter: 'blur(5px)',
//             zIndex: 9999,
//           }}
//         >
//           <div className="spinner-border text-primary" role="status" style={{ width: '4rem', height: '4rem' }}>
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       )}

//       <div className={`container mt-4 ${loading ? 'blur' : ''}`}>
//         <h2>My Content</h2>
//         <form onSubmit={handleSubmit} className="mb-4">
//           <input
//             type="text"
//             name="title"
//             value={form.title}
//             onChange={handleChange}
//             placeholder="Title"
//             className="form-control mb-2"
//             required
//           />
//           <textarea
//             name="body"
//             value={form.body}
//             onChange={handleChange}
//             placeholder="Body"
//             className="form-control mb-2"
//             required
//           />

//           {/* Category Dropdown */}
//           <select
//             name="category"
//             value={form.category}
//             onChange={handleChange}
//             className="form-select mb-2"
//             required
//           >
//             <option value="">Select Category</option>
//             <option value="tech">Technology</option>
//             <option value="news">News</option>
//             <option value="life">Lifestyle</option>
//             <option value="sports">Sports</option>
//             <option value="other">Other</option>
//           </select>

//           {/* Custom Category Input */}
//           {form.category === 'other' && (
//             <input
//               type="text"
//               name="customCategory"
//               value={form.customCategory}
//               onChange={handleChange}
//               placeholder="Enter custom category"
//               className="form-control mb-2"
//               required
//             />
//           )}

//           {/* Subcategory Dropdown */}
//           <select
//             name="subcategory"
//             value={form.subcategory}
//             onChange={handleChange}
//             className="form-select mb-2"
//             required
//           >
//             <option value="">Select Subcategory</option>
//             <option value="ai">AI</option>
//             <option value="gadgets">Gadgets</option>
//             <option value="health">Health</option>
//             <option value="finance">Finance</option>
//             <option value="other">Other</option>
//           </select>

//           {/* Custom Subcategory Input */}
//           {form.subcategory === 'other' && (
//             <input
//               type="text"
//               name="customSubcategory"
//               value={form.customSubcategory}
//               onChange={handleChange}
//               placeholder="Enter custom subcategory"
//               className="form-control mb-2"
//               required
//             />
//           )}
//           <input
//             type="file"
//             onChange={handleFileChange}
//             accept="image/*,video/*,application/pdf"
//             className="form-control mb-2"
//           />




//           <button className="btn btn-primary">Post</button>
//         </form>

//         <div className="accordion" id="contentAccordion">
//           {contents.map((item, index) => (
//             <div className="accordion-item" key={item.id}>
//               <h2 className="accordion-header" id={`heading${index}`}>
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target={`#collapse${index}`}
//                   aria-expanded="false"
//                   aria-controls={`collapse${index}`}
//                 >
//                   {item.title}{item.is_public && <span className="ms-2" title="Public Post">
//                     🌍 {item.category && <span>({item.category})</span>}
//                   </span>}

//                 </button>
//               </h2>
//               <div
//                 id={`collapse${index}`}
//                 className="accordion-collapse collapse"
//                 aria-labelledby={`heading${index}`}
//                 data-bs-parent="#contentAccordion"
//               >
//                 <div className="accordion-body">
//                   {editingId === item.id ? (
//                     <>
//                       <input
//                         type="text"
//                         name="title"
//                         value={editForm.title}
//                         onChange={handleEditChange}
//                         className="form-control mb-2"
//                       />
//                       <textarea
//                         name="body"
//                         value={editForm.body}
//                         onChange={handleEditChange}
//                         className="form-control mb-2"
//                       />
//                       <button className="btn btn-success btn-sm me-2" onClick={() => submitEdit(item.id)}>
//                         Save
//                       </button>
//                       <button className="btn btn-secondary btn-sm" onClick={() => setEditingId(null)}>
//                         Cancel
//                       </button>
//                     </>
//                   ) : (
//                     <>
//                       <p>{item.body}</p>
//                       <button className="btn btn-outline-primary btn-sm me-2" onClick={() => startEdit(item)}>
//                         Edit
//                       </button>
//                       <button className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(item.id)}>
//                         Delete
//                       </button>
//                       {/* <button className="btn btn-outline-warning btn-sm me-2"
//                         onClick={() => handlePostGlobal(item.id)}
//                         disabled={item.is_public} // disable if already global
//                       >
//                         {item.is_public ? "Posted Globally" : "Post Globally"}  
//                       </button> */}
//                       {item.is_public ? (
//                         <button
//                           className="btn btn-warning btn-sm me-2"
//                           onClick={() => togglePublic(item.id, false)}
//                         >
//                           Unpublish
//                         </button>
//                       ) : (
//                         <button
//                           className="btn btn-outline-success btn-sm me-2"
//                           onClick={() => togglePublic(item.id, true)}
//                         >
//                           Make Public
//                         </button>
//                       )}
//                       {item.file_url && (
//                         <>
//                           {item.file_type === 'image' && (
//                             <img src={item.file_url} alt="content" className="img-fluid mb-2" />
//                           )}
//                           {item.file_type === 'video' && (
//                             <video src={item.file_url} controls className="w-100 mb-2" />
//                           )}
//                           {item.file_type === 'application' && (
//                             <a href={item.file_url} target="_blank" rel="noreferrer">
//                               📄 View PDF
//                             </a>
//                           )}
//                         </>
//                       )}


//                     </>

//                   )}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MyContent;
import { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../components/baseurl';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

axios.defaults.baseURL = API_BASE_URL;

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    res => res,
    async err => {
      const originalRequest = err.config;
      if (err.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          try {
            const res = await axios.post('/api/token/refresh/', { refresh: refreshToken });
            localStorage.setItem('access_token', res.data.access);
            axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.access}`;
            originalRequest.headers['Authorization'] = `Bearer ${res.data.access}`;
            return axios(originalRequest);
          } catch (error) {
            toast.error("Session expired. Please login again.");
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
          }
        }
      }
      return Promise.reject(err);
    }
  );
};

const MyContent = () => {
  const [contents, setContents] = useState([]);
  const [form, setForm] = useState({
    title: '',
    body: '',
    category: '',
    customCategory: '',
    subcategory: '',
    customSubcategory: '',
    file: null,
    fileUrl: '',
    fileType: '',
  });

  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ title: '', body: '' });
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [preview, setPreview] = useState(null);

  const accessToken = localStorage.getItem('access_token');

  useEffect(() => {
    setupAxiosInterceptors();

    if (!accessToken) return;
    setLoading(true);
    axios
      .get('/api/my-content/', {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((res) => setContents(res.data))
      .catch((err) => toast.error('Failed to load content'))
      .finally(() => setLoading(false));
  }, [accessToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'my_upload_preset');
    formData.append('folder', 'my_folder'); // optional
    setIsUploading(true);

    setPreview(null);
    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dzyrb5mtg/auto/upload',
        formData
      );

      const secureUrl = res.data.secure_url;

      setForm((prev) => ({
        ...prev,
        file: file,
        fileUrl: secureUrl,
        fileType: file.type.split('/')[0],
      }));

      setPreview({ type: file.type.split('/')[0], url: secureUrl });
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed! Check preset and network.");
      // Fallback
    } finally {
      setIsUploading(false);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalCategory = form.category === 'other' ? form.customCategory : form.category;
    const finalSubcategory = form.subcategory === 'other' ? form.customSubcategory : form.subcategory;

    const formData = {
      title: form.title,
      body: form.body,
      category: finalCategory,
      subcategory: finalSubcategory,
      file_url: form.fileUrl,
      file_type: form.fileType,
    };
    try {
      const res = await axios.post('/api/my-content/', formData, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setContents((prev) => [res.data, ...prev]);
      setForm({
        title: '',
        body: '',
        category: '',
        customCategory: '',
        subcategory: '',
        customSubcategory: '',
        file: null,
        fileUrl: '',
        fileType: '',
      });
      toast.success("Content posted successfully");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error posting content");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/my-content/${id}/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setContents((prev) => prev.filter((item) => item.id !== id));
      toast.success("Content deleted");
    } catch (err) {
      toast.error("Failed to delete content");
    }
  };

  const togglePublic = async (id, makePublic) => {
    try {
      const res = await axios.patch(
        `/api/my-content/${id}/`,
        { is_public: makePublic },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      setContents((prev) =>
        prev.map((item) => (item.id === id ? res.data : item))
      );
      toast.success("Global visibility updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to change visibility");
    }
  };

  const startEdit = (content) => {
    setEditingId(content.id);
    setEditForm({ title: content.title, body: content.body });
  };

  const handleEditChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  const submitEdit = async (id) => {
    try {
      const res = await axios.put(`/api/my-content/${id}/`, editForm, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setContents((prev) => prev.map((item) => (item.id === id ? res.data : item)));
      setEditingId(null);
      toast.success("Content updated");
    } catch (err) {
      toast.error("Failed to update content");
    }
  };

  if (!accessToken) {
    return <p>Please login to see your content.</p>;
  }

  return (
    <div className="position-relative">
      <ToastContainer />

      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(5px)',
            zIndex: 9999,
          }}
        >
          <div className="spinner-border text-primary" role="status" style={{ width: '4rem', height: '4rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className={`container mt-4 ${loading ? 'blur' : ''}`}>
        <h2>My Content</h2>

        <form onSubmit={handleSubmit} className="mb-4">
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Title"
            className="form-control mb-2"
            required
          />
          <textarea
            name="body"
            value={form.body}
            onChange={handleChange}
            placeholder="Body"
            className="form-control mb-2"
            required
          />

          <select
            name="category"
            value={form.category}
            onChange={handleChange}
            className="form-select mb-2"
            required
          >
            <option value="">Select Category</option>
            <option value="tech">Technology</option>
            <option value="news">News</option>
            <option value="life">Lifestyle</option>
            <option value="sports">Sports</option>
            <option value="other">Other</option>
          </select>

          {form.category === 'other' && (
            <input
              type="text"
              name="customCategory"
              value={form.customCategory}
              onChange={handleChange}
              placeholder="Enter custom category"
              className="form-control mb-2"
              required
            />
          )}

          <select
            name="subcategory"
            value={form.subcategory}
            onChange={handleChange}
            className="form-select mb-2"
            required
          >
            <option value="">Select Subcategory</option>
            <option value="ai">AI</option>
            <option value="gadgets">Gadgets</option>
            <option value="health">Health</option>
            <option value="finance">Finance</option>
            <option value="other">Other</option>
          </select>

          {form.subcategory === 'other' && (
            <input
              type="text"
              name="customSubcategory"
              value={form.customSubcategory}
              onChange={handleChange}
              placeholder="Enter custom subcategory"
              className="form-control mb-2"
              required
            />
          )}

          <input
            type="file"
            onChange={handleFileChange}
            accept="image/*,video/*,.pdf"
            className="form-control mb-2"
            disabled={isUploading}
          />

          {isUploading && <p>Uploading file...</p>}

          {preview && (
            <div style={{ marginTop: "10px" }}>
              {preview.type === "image" && (
                <img
                  src={preview.url}
                  alt="preview"
                  style={{ maxWidth: "300px", maxHeight: "300px" }}
                  onLoad={() => console.log("Image loaded")}
                />
              )}
              {preview.type === "video" && (
                <video controls width="300">
                  <source src={preview.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              {form.fileType === "application" && form.fileUrl.endsWith(".pdf") && (
      <object
        data={form.fileUrl}
        type="application/pdf"
        width="300"
        height="400"
      >
        <p>
          Your browser doesn't support PDF previews.{" "}
          <a href={form.fileUrl} target="_blank" rel="noopener noreferrer">
            Open PDF
          </a>
        </p>
      </object>
    )}
            </div>
          )}

          <button type="submit" disabled={isUploading}>
            Post
          </button>
        </form>

        {/* Accordion display logic remains unchanged */}
        {/* You already handle image, video, and pdf display correctly */}
        {/* Rest of content list rendering is untouched */}
        <div className="accordion" id="contentAccordion">
          {contents.map((item, index) => (
            <div className="accordion-item" key={item.id}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {item.title}{item.is_public && <span className="ms-2" title="Public Post">
                    🌍 {item.category && <span>({item.category})</span>}
                  </span>}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${index}`}
                data-bs-parent="#contentAccordion"
              >
                <div className="accordion-body">
                  {editingId === item.id ? (
                    <>
                      <input
                        type="text"
                        name="title"
                        value={editForm.title}
                        onChange={handleEditChange}
                        className="form-control mb-2"
                      />
                      <textarea
                        name="body"
                        value={editForm.body}
                        onChange={handleEditChange}
                        className="form-control mb-2"
                      />
                      <button className="btn btn-success btn-sm me-2" onClick={() => submitEdit(item.id)}>
                        Save
                      </button>
                      <button className="btn btn-secondary btn-sm" onClick={() => setEditingId(null)}>
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <p>{item.body}</p>
                      <button className="btn btn-outline-primary btn-sm me-2" onClick={() => startEdit(item)}>
                        Edit
                      </button>
                      <button className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(item.id)}>
                        Delete
                      </button>
                      {item.is_public ? (
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => togglePublic(item.id, false)}
                        >
                          Unpublish
                        </button>
                      ) : (
                        <button
                          className="btn btn-outline-success btn-sm me-2"
                          onClick={() => togglePublic(item.id, true)}
                        >
                          Make Public
                        </button>
                      )}
                      {item.file_url && (
                        <>
                          {item.file_type === 'image' && (
                            <img src={item.file_url} alt="content" className="img-fluid mb-2" />
                          )}
                          {item.file_type === 'video' && (
                            <video src={item.file_url} controls className="w-100 mb-2" />
                          )}
                          {item.file_type === 'application' && (
                            <a href={item.file_url} target="_blank" rel="noreferrer">
                              📄 View PDF
                            </a>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyContent;


